import React from 'react';

import WpButton, { Color } from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';

const DEFAULT_TITLE = 'Are you sure?';
const DEAFULT_MESSAGE = 'Are you sure?';
const DEFAULT_CONFIRM_BUTTON_LABEL = "Yes, I'm sure";
const DEFAULT_CONFIRM_BUTTON_COLOR = 'danger';
const DEFAULT_CANCEL_BUTTON_LABEL = 'Cancel';

type Props = {
  isOpen: boolean;
  onToggle: Function;
  title?: string;
  message?: string;
  children?: React.ReactNode;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  confirmButtonColor?: Color;
  isProcessing?: boolean;
  isConfirmDisabled?: boolean;
  onConfirmClick: (event: React.MouseEvent) => void;
};

function ConfirmModal({
  isOpen,
  onToggle,
  title = DEFAULT_TITLE,
  message = DEAFULT_MESSAGE,
  children,
  isProcessing = false,
  isConfirmDisabled = false,
  cancelButtonLabel = DEFAULT_CANCEL_BUTTON_LABEL,
  confirmButtonColor = DEFAULT_CONFIRM_BUTTON_COLOR,
  confirmButtonLabel = DEFAULT_CONFIRM_BUTTON_LABEL,
  onConfirmClick,
}: Props) {
  const body = children || message;
  return (
    <WpModal isOpen={isOpen} size="sm" onToggle={() => onToggle()} dismissOnBackdrop={false}>
      <WpModalHeader>{title}</WpModalHeader>
      <WpModalBody>{body}</WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton variant="tertiary" onClick={() => onToggle()} disabled={isProcessing}>
            {cancelButtonLabel}
          </WpButton>
          <WpButton
            qaTest="confirm-button"
            onClick={onConfirmClick}
            color={confirmButtonColor}
            disabled={isConfirmDisabled}
            loading={isProcessing}
          >
            {confirmButtonLabel}
          </WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
}

export default ConfirmModal;
